import 'jquery';
import 'slick-carousel';
import initFeatherlight from 'featherlight'
import './navigation';
import './search';
import Splide from '@splidejs/splide';
import 'fslightbox';
// Blocks are bulk imported at compile time

initFeatherlight();

jQuery(function($) {
  $('ul.tabs-nav-hover').each(function(){
		// For each set of tabs, we want to keep track of
		// which tab is active and its associated content
		var $active, $content, $links = $(this).find('a');
		//var $activeLi = $(this).find('li.tab');
		
		// If the location.hash matches one of the links, use that as the active tab.
		// If no match is found, use the first link as the initial active tab.
		$active = $($links.filter('[href="'+location.hash+'"]')[0] || $links[0]);
		$active.addClass('active');
		//$activeLi.addClass('active');
		
		$content = $($active[0].hash);
		
		// Hide the remaining content
		$links.not($active).each(function () {
			$(this.hash).hide();
		});
		
		// Bind the mouseover event handler
		$(this).on('mouseover', 'a', function(e) {
			// Make the old tab inactive.
			$active.removeClass('active');
			//$activeLi.removeClass('active');
			$content.hide();
			
			// Update the variables with the new link and content
			$active = $(this);
			$content = $(this.hash);
			
			// Make the tab active.
			$active.addClass('active');
			$content.show();
			
			// Prevent the anchor's default click action
			e.preventDefault();
		});

		// Go to URL on click DISABLED UNTIL POST LAUNCH
		$(this).on('click', 'a', function(e) {
      if ($(this).attr('data-url') === '#') {
        e.preventDefault;
      } else {
        window.location.href = $(this).attr('data-url');
      }			
			e.preventDefault();
		});

	});

})

const b105TestimonialSlider = document.querySelector('.b105-slider');
if (b105TestimonialSlider) {
    let updateHeight = newIndex => {
      let slide = testySplide.Components.Slides.getAt( typeof( newIndex ) == 'number' ? newIndex : testySplide.index ).slide;
      slide.parentElement.parentElement.style.height = slide.offsetHeight + 'px';
    };
    testySplide = new Splide(b105TestimonialSlider, {
        'type' : 'fade',
        'rewind' : true,
        'width' : '1166px',
        'arrows' : false,
        'pagination' : false,
        'autoplay' : true,
        'interval' : 10000,
        'pauseOnHover' : false
    }).mount().on('move resize', updateHeight);
    updateHeight();
}

const b109Slider = document.querySelector('.b109-slider');
if (b109Slider) {
  new Splide(b109Slider, {
    'type' : 'slide',
    'rewind' : true,
    'fixedWidth' : '150px',
    'fixedHeight' : '150px',
    'perPage' : 5,
    'perMove' : 1,
    'gap' : '85px',
    'arrows' : false,
    'pagination' : false
  }).mount();
}

const accs = document.getElementsByClassName('accordion-toggle');
let i;

for (i = 0; i < accs.length; i++) {
  accs[i].addEventListener("click", function() {
    this.classList.toggle("active");
    var panel = this.nextElementSibling;
    if (panel.style.maxHeight) {
      panel.style.maxHeight = null;
    } else {
      panel.style.maxHeight = panel.scrollHeight + "px";
    }
  });
}

